<svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
  <path d="M3 10 12 3 21 10V21H3Z" />
  <path d="M9 21V13H15V21" />
</svg>
